import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CyPlaylistIndex } from "./CyPlaylistIndex";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PlaylistIndexManipulator } from "./PlaylistIndexManipulator";
import { Fab } from "../common/components/Fab";
import { PlaylistRoutePaths } from "../playlist/PlaylistRoutePaths";
import { generateId } from "../common/UrlFriendlyNanoIdGeneration";

interface Props {
  currentCrewIdentifier: string | undefined;
}

export function NewPlaylistFab({ currentCrewIdentifier }: Props) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  function createPlaylistAndOpen() {
    const identifierToCreate = generateId();
    PlaylistIndexManipulator.createPlaylist(
      identifierToCreate,
      currentCrewIdentifier,
    );
    navigate(PlaylistRoutePaths.toCarousel(identifierToCreate));
  }

  return (
    <Fab
      onClick={() => createPlaylistAndOpen()}
      data-cy={CyPlaylistIndex.ButtonAddPlaylist}
    >
      <FontAwesomeIcon icon={faCirclePlus} /> {t("playlist.index.addPlaylist")}
    </Fab>
  );
}
